import { Button } from "antd"
import { ServiceCategory } from "src/common/models/serviceCategory"

interface Props {
    selected?: boolean
    serviceCatgory: ServiceCategory
    onClick: (serviceCategory: ServiceCategory) => void
}

export const CategoryButton = (props: Props) => {
    return (
        <Button
            type={props.selected ? "primary" : "default"}
            shape="round"
            onClick={() => {
                props.onClick(props.serviceCatgory)
            }}
        >
            {props.serviceCatgory.name}
        </Button>
    )
}
